import { render } from "./step.vue?vue&type=template&id=5d0c9bd2&scoped=true"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"

import "./step.vue?vue&type=style&index=0&id=5d0c9bd2&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0c9bd2"],['__file',"src/components/public/step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d0c9bd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d0c9bd2', __exports__)) {
    console.log('reload')
    api.reload('5d0c9bd2', __exports__)
  }
  
  module.hot.accept("./step.vue?vue&type=template&id=5d0c9bd2&scoped=true", () => {
    console.log('re-render')
    api.rerender('5d0c9bd2', render)
  })

}


export default __exports__